import { render } from "./Card.vue?vue&type=template&id=d553cbf8"
import script from "./card.ts?vue&type=script&lang=js"
export * from "./card.ts?vue&type=script&lang=js"

import "./card.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script